import { WebParameterContext, WebResponesContext } from '../../model/common';
export class ServicesBirthdaytx{
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    webcontext.RequestBody={};
    webcontext.RequestBody.Type=4;//生日提醒
    return webcontext;
  }

}